import { Identifiers } from "@angular/compiler";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";

export class SessionUser {
	id: string;
	firstName: string;
	lastName: string;
	identifier: Identifiers;
	temporaryPassword: boolean;
	superAdmin: boolean;
	configured: boolean;
	isPartner: boolean;
	alertDemo: boolean;
	planes: PlanUsuario[];
	email: string;
	cargo: string;
	certificadoVigente: boolean;
	tieneEmpresasInactivas: boolean;
	cantidadEmpresasActivas: number;
	cantidadEmpresasInactivas: number;
	requiereRegularizacionAutomatica: boolean;
	constructor(idInput: string, nameInput: string, lastNameInput: string, identifierInput: Identifiers, temporaryPassword: boolean, superAdmin: boolean, configured: boolean, alertDemo: boolean, planes: PlanUsuario[], email: string, cargo: string, isPartner: boolean, certificadoVigente: boolean,tieneEmpresasInactivas: boolean = false, cantidadEmpresasActivas: number = 0,
    cantidadEmpresasInactivas: number = 0,requiereRegularizacionAutomatica: boolean = false) {
		this.id = idInput;
		this.firstName = nameInput;
		this.lastName = lastNameInput;
		this.identifier = identifierInput;
		this.temporaryPassword = temporaryPassword;
		this.superAdmin = superAdmin;
		this.configured = configured;
		this.alertDemo = alertDemo;
		this.planes = planes;
		this.cargo = cargo;
		this.email = email;
		this.isPartner = isPartner;
		this.certificadoVigente = certificadoVigente;
		this.tieneEmpresasInactivas = tieneEmpresasInactivas;
        this.cantidadEmpresasActivas = cantidadEmpresasActivas;
        this.cantidadEmpresasInactivas = cantidadEmpresasInactivas;
        this.requiereRegularizacionAutomatica = requiereRegularizacionAutomatica;
	};
	
}
